import 'angular';

import restButtonDirective from '../rest-button';

import chooseDirective from './choose';
import newChooseDirective from './new-choose';
import formDirective from './form';
import genericAutoOptions from './generic-form-auto';
import genericAutoNamedOptions from './generic-form-auto-named';
import genericByGroupAutoNamedOptions from './generic-form-by-group-auto-named';
import callGroupsDirective from './call-groups';
import callUsersDirective from './call-selected-users';
import callCustomUsersDirective, { callCustomSelectedUsersAPIV2Filter } from './call-selected-users-custom';
import callUsersNamedDirective from './call-selected-users-named';
import callUserListDirective from './call-user-list';

const MODULE_NAME = 'daupler.incidents.components.buttons.team';

var app = angular.module(MODULE_NAME, []);
app.directive('chooseTeam', chooseDirective);
app.directive('chooseTeamNew', newChooseDirective);
app.directive('formTeam', formDirective);
app.controller('TeamController', teamController);
app.directive('genericFormAuto', restButtonDirective(genericAutoOptions));
app.directive('genericFormAutoNamed', restButtonDirective(genericAutoNamedOptions));
app.directive('genericFormByGroupAutoNamed', restButtonDirective(genericByGroupAutoNamedOptions));
app.directive('callGroupsForTeam', callGroupsDirective);
app.directive('callSelectedUsers', callUsersDirective);
app.directive('callSelectedUsersNamed', callUsersNamedDirective);
app.directive('callSelectedUsersCustom', callCustomUsersDirective);
app.filter('callSelectedUsersCustomAPIV2Transform', callCustomSelectedUsersAPIV2Filter);
app.directive('formTeamSequential', callUserListDirective);


function teamController() {
	var vm = this;

	vm.toggle = function(array, obj) {
		var idx = array.indexOf(obj);
		if (idx > -1) {
			array.splice(idx, 1);
		} else {
			array.push(obj);
		}
	}
}

export default MODULE_NAME;
